import { FieldType, BaseRateRequest } from '@pmp/api';
import { CrudMode, FormItem, SelectsOptions, RenderFormItem, transformUppercaseNoSpaces } from '@ohpen/enso-ui';
import { DEFAULT_TEXT_MAX_LENGTH_SHORT, textLimitProps, withColumnDecimals } from '@pmp/utils';

import { baseRateChangeColumns, interestRateColumns } from './tableConfig';

const baseRatesFormSchema = (
  selectsOptions: SelectsOptions,
  renderAlert: RenderFormItem<BaseRateRequest>,
  mode?: CrudMode | null,
): FormItem[] => [
  {
    renderFormItem: renderAlert,
  },
  {
    title: 'pmp.baseRates.labels.baseRateId',
    dataIndex: 'code',
    formItemProps: {
      required: mode === CrudMode.CREATE,
      getValueFromEvent: transformUppercaseNoSpaces,
    },
    fieldProps: {
      disabled: mode !== CrudMode.CREATE,
      ...textLimitProps(DEFAULT_TEXT_MAX_LENGTH_SHORT),
    },
  },
  {
    title: 'pmp.baseRates.labels.baseRateName',
    dataIndex: 'name',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
      ...textLimitProps(DEFAULT_TEXT_MAX_LENGTH_SHORT),
    },
  },
  {
    title: 'pmp.baseRates.labels.variabilityType',
    dataIndex: 'variabilityType',
    valueType: 'select',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      options: selectsOptions[FieldType.VARIABILITY_TYPE],
      disabled: mode !== CrudMode.CREATE,
    },
  },
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'amount',
    valueType: 'percent',
    dependencies: ['variabilityType'],
    formItemProps: form => ({
      required: true,
    }),
    fieldProps: {
      disabled: mode !== CrudMode.CREATE,
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    valueType: 'date',
    dependencies: ['variabilityType'],
    formItemProps: form => ({
      required: true,
    }),
    fieldProps: {
      disabled: mode !== CrudMode.CREATE,
    },
  },
  {
    title: 'pmp.baseRates.labels.endDate',
    dataIndex: 'endDate',
    valueType: 'date',
    formItemProps: {
      hidden: mode !== CrudMode.VIEW,
    },
    fieldProps: {
      disabled: true,
    },
  },
];

export const getBaseRatesFormSchema = (...args: Parameters<typeof baseRatesFormSchema>): FormItem[] =>
  withColumnDecimals(baseRatesFormSchema(...args), baseRateChangeColumns);

const interestRatesFormSchema = (mode?: CrudMode | null): FormItem[] => [
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'amount',
    valueType: 'percent',
    formItemProps: {
      required: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    valueType: 'date',
    formItemProps: {
      required: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.index',
    dataIndex: 'index',
    formItemProps: {
      hidden: mode === CrudMode.CREATE,
    },
    fieldProps: {
      disabled: true,
    },
  },
];

export const getInterestRatesFormSchema = (...args: Parameters<typeof interestRatesFormSchema>): FormItem[] =>
  withColumnDecimals(interestRatesFormSchema(...args), interestRateColumns);
